import Vue from 'vue'
import Messages from '../components/Messages.vue'

export default Vue.mixin({
    components: {
        Messages
    },
    data() {
        return {
            messages: []
        }
    },
    methods: {
        addMessage(variant, messageText, timeoutMs = 5000) {
            if(Array.isArray(messageText)) {
                messageText.forEach((value) => this.addMessage(variant, value, timeoutMs))
                return undefined
            }

            let messageObj = {
                variant,
                text: messageText,
                close: this.clearMessage.bind(messageObj)
            }

            this.messages.push(messageObj)
            setTimeout(()=> messageObj.close(), timeoutMs)
            return messageObj
        },
        clearMessage(messageObj) {
            let indexOfMessage = this.messages.indexOf(messageObj)
            this.messages.splice(indexOfMessage, 1)
        },
        clearMessages() {
            this.messages = []
        },
        getMessages() {
            return this.messages
        },
        addError(messageText, timeoutMs = 5000) {
            return this.addMessage('danger', messageText, timeoutMs)
        },
        addSuccess(messageText, timeoutMs = 5000) {
            return this.addMessage('success', messageText, timeoutMs)
        },
        addWarning(messageText, timeoutMs = 5000) {
            return this.addMessage('warning', messageText, timeoutMs)
        },
        parseAPIErrorsOrRethrow(err, withMessage) {
            if (!err.response || err.response.status > 499) {
                throw err
            }

            let messages = []

            function handleError(errMessage, key) {
                let msg = key ? `${key}: ${errMessage}` : errMessage

                if ('function' === typeof withMessage) {
                    msg = withMessage.call(null, key, errMessage)
                }

                messages.push(msg)
            }

            try {
                for (let key in err.response.data) {
                    let thisErr = err.response.data[key]

                    if (key === 'non_field_errors' && Array.isArray(thisErr)) {
                        for (let fieldKey in thisErr) {
                            handleError(thisErr[fieldKey])
                        }
                    } else if (Array.isArray(thisErr)) {
                        for (let fieldKey in thisErr) {
                            handleError(thisErr[fieldKey], key)
                        }
                    } else {
                        handleError(thisErr, key)
                    }
                }

                return messages
            } catch (_e) {
                console.warn(_e.message)
                throw err
            }
        },
    },
})
